import { ConfigProvider, Form, Input, message, Modal } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import container from "@/lib/di/container";
import { ElectronicContractRepo } from "@/core/repos/tables/electronic-contract.repo";
import React from "react";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { usePermissionStore } from "@/core/stores/permission.store";
import { SaveButton } from "@/app/home/components/table/SaveButton";
import { ElectronicContractModel, CreateElectronicContractModel } from "@/core/models/electronic-contract.model";

const electronicContractRepo = container.get(ElectronicContractRepo);

interface DetailModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data: ElectronicContractModel,
    waterUserCode: string,
    onSuccess?: () => void,
}

const INPUT_WIDTH = 450;

export const DetailModal: React.FC<DetailModalProps> = ({isModalOpen, setIsModalOpen, data, waterUserCode, onSuccess}) => {
    const permissionStore = usePermissionStore();
    const [form] = Form.useForm<CreateElectronicContractModel>();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (data.id && data.id.length > 0) {
            setIsEdit(true);
            form.setFieldsValue({
                waterUserCode: data.waterUserCode || waterUserCode,
                templateId: data.templateId || ""
            });
        } else {
            setIsEdit(false);
            // Set default templateId when creating new contract
            form.setFieldsValue({
                waterUserCode: waterUserCode || data.waterUserCode || "",
                templateId: "DF02483B-9376-4C62-8202-0222EC7DA2FD"
            });
        }
    }, [data, waterUserCode, form]);

    const handleSave = async () => {
        try {
            setLoading(true);
            const formData = await form.validateFields();
            
            if (isEdit) {
                messageApi.warning({
                    content: "Chức năng chỉnh sửa hợp đồng điện tử chưa được hỗ trợ"
                });
            } else {
                const result = await electronicContractRepo.createContract({
                    ...formData,
                    waterUserCode: waterUserCode
                });
                setIsModalOpen(false);
                if (result) {
                    messageApi.success({
                        content: "Tạo hợp đồng điện tử thành công"
                    });
                    if (onSuccess) {
                        onSuccess();
                    }
                } else {
                    messageApi.error({
                        content: "Tạo hợp đồng điện tử thất bại"
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            {contextHolder}
            <Modal 
                open={isModalOpen} 
                onCancel={handleCancel} 
                width={980} 
                centered
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={[
                    <div key={1} className="w-full flex flex-row justify-end px-1.5">
                        <SaveButton isEdit={isEdit} loading={loading} onClick={handleSave}/>
                    </div>,
                ]}
            >
                <div className="flex flex-row w-full items-center justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">
                        {isEdit ? "CHI TIẾT HỢP ĐỒNG ĐIỆN TỬ" : "TẠO HỢP ĐỒNG ĐIỆN TỬ"}
                    </p>
                </div>
                <div className="flex flex-row justify-center mt-6">
                    <Form<CreateElectronicContractModel>
                        name="basic"
                        className="flex flex-col items-end"
                        form={form}
                        layout="vertical"
                        disabled={isEdit && !permissionStore.page.edit}
                    >
                        <div className="grid grid-cols-1 gap-x-4 items-end">
                            <Form.Item<CreateElectronicContractModel>
                                label="Mã khách hàng"
                                name="waterUserCode"
                                rules={[{ required: true, message: 'Mã khách hàng là bắt buộc!' }]}
                            >
                                <Input 
                                    placeholder="Mã khách hàng" 
                                    style={{width: INPUT_WIDTH}}
                                    disabled
                                ></Input>
                            </Form.Item>
                            {!isEdit && (
                                <Form.Item<CreateElectronicContractModel>
                                    name="templateId"
                                    hidden
                                >
                                    <Input type="hidden" />
                                </Form.Item>
                            )}
                        </div>
                    </Form>
                </div>
                <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
            </Modal>
        </ConfigProvider>
    );
};

